import BillingProfiles from "@/modules/billingProfile/views/BillingProfiles.vue";
import BillingProfilesEdit from "@/modules/billingProfile/views/BillingProfileEdit.vue";
import BillingProfileView from "@/modules/billingProfile/views/BillingProfileView.vue";

export const BillingRoutes = [
    {
        path: '/billing/profiles',
        component: BillingProfiles,
    },
    {
        path: '/billing/profiles/create',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/createbycustomer',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/edit',
        component: BillingProfilesEdit,
    },
    {
        path: '/billing/profiles/view/admin',
        component: BillingProfileView,
    },
    {
        path: '/billing/profiles/view/user',
        component: BillingProfileView,
    }
];
